import React, { useEffect, useRef, useState } from 'react';
import { TreatmentType } from '../models/superbit-api-models';
import { Select, TimePicker  } from 'antd';
import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
// import 'antd/dist/antd.css';

type Props = {
    ClosePopup?: Function;
    OnApprove?: Function;
    config?: any;
    messageTitle?: string;
};

const ClientTreatmentTabConfigPopup = (props: Props) => {
    const editorRef = useRef<TinyMCEEditor | null>(null);
    const CreatedDateRef = React.createRef<DatePicker>();
    const ReminderDateRef = React.createRef<DatePicker>();
    const CustomerBirthDateRef = React.createRef<DatePicker>();
    const IdentityIssueDateRef = React.createRef<DatePicker>();
    const DriverLicensIssueDateRef = React.createRef<DatePicker>();

    const [tab, setTab] = useState<string>('Template');
    

    const closePopup = (status?: string)=>{
        if (props.ClosePopup) {
            props.ClosePopup(status);  
         }
    }

    const approve = () => {
        if (props.OnApprove) {
            props.OnApprove();
        }
    }
    
    const selectTab = (tabName: string) => {
        setTab(tabName);
    }

    const emptyFunc = () => {}

    useEffect(()=>{
    },[])
    
      return ( <>
        <div className={`popup-wrapper treatment-config-popup`}>
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e:any)=>closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {props.messageTitle}
                        </div>
                    </div>
                    <div className="popup-body">
                        <div className="clients-tabs-client-card-tabs client-details-view">
                            <div className={`client-card-tab pointer ${tab == 'Template' ? 'selected' : ''}`} onClick={()=>selectTab('Template')}>
                                <div className="label">
                                    תבנית
                                </div>
                                <div className="under-line"></div>
                            </div>
                        </div>
                        <div className='flex-space-between'>
                            <div className='config-right-side'>
                                <div className="parameter-row single-item">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            נתוני סוכנות:
                                            </div>
                                            <div className="value">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    placeholder="כל המטפלים"
                                                    defaultValue={''}
                                                    value={''}
                                                    onChange={emptyFunc}
                                                    options={
                                                        [
                                                            {
                                                                label: 'פרטי חברה',
                                                                value: 1
                                                            },
                                                            {
                                                                label: 'פרטי משתמש',
                                                                value: 2
                                                            }
                                                        ]
                                                    }
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row single-item">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            נתוני מעסיק:
                                            </div>
                                            <div className="value">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    placeholder="כל המטפלים"
                                                    defaultValue={''}
                                                    value={''}
                                                    onChange={emptyFunc}
                                                    options={
                                                        [
                                                            {
                                                                label: 'שם מעסיק',
                                                                value: 1
                                                            },
                                                            {
                                                                label: 'ח.פ. מעסיק',
                                                                value: 2
                                                            },
                                                            {
                                                                label: 'איש קשר מעסיק',
                                                                value: 3
                                                            },
                                                            {
                                                                label: 'כתובת',
                                                                value: 4
                                                            }
                                                        ]
                                                    }
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row single-item">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            נתוני לקוח:
                                            </div>
                                            <div className="value">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    placeholder="כל המטפלים"
                                                    defaultValue={''}
                                                    value={''}
                                                    onChange={emptyFunc}
                                                    options={
                                                        [
                                                            {
                                                                label: 'שם לקוח',
                                                                value: 1
                                                            },
                                                            {
                                                                label: 'שם פרטי',
                                                                value: 2
                                                            },
                                                            {
                                                                label: 'שם משפחה',
                                                                value: 3
                                                            },
                                                            {
                                                                label: 'ת.ז.',
                                                                value: 4
                                                            }
                                                        ]
                                                    }
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row single-item">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            נתוני פוליסה:
                                            </div>
                                            <div className="value">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    placeholder="כל המטפלים"
                                                    defaultValue={''}
                                                    value={''}
                                                    onChange={emptyFunc}
                                                    options={
                                                        [
                                                            {
                                                                label: 'כללי',
                                                                value: 1
                                                            },
                                                            {
                                                                label: 'נתוני דירה',
                                                                value: 2
                                                            },
                                                            {
                                                                label: 'נתוני רכב',
                                                                value: 3
                                                            },
                                                            {
                                                                label: 'נתוני גביה',
                                                                value: 4
                                                            }
                                                        ]
                                                    }
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row single-item">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            נתוני הצעה:
                                            </div>
                                            <div className="value">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    placeholder="כל המטפלים"
                                                    defaultValue={''}
                                                    value={''}
                                                    onChange={emptyFunc}
                                                    options={
                                                        [
                                                            {
                                                                label: 'כללי',
                                                                value: 1
                                                            },
                                                            {
                                                                label: 'נתוני דירה',
                                                                value: 2
                                                            },
                                                            {
                                                                label: 'פרמיה',
                                                                value: 3
                                                            }
                                                        ]
                                                    }
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row single-item">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            נתוני תביעה:
                                            </div>
                                            <div className="value">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    placeholder="כל המטפלים"
                                                    defaultValue={''}
                                                    value={''}
                                                    onChange={emptyFunc}
                                                    options={
                                                        [
                                                            {
                                                                label: 'כללי',
                                                                value: 1
                                                            },
                                                            {
                                                                label: 'נפגעים',
                                                                value: 2
                                                            },
                                                            {
                                                                label: 'נתוני נעג',
                                                                value: 3
                                                            },
                                                            {
                                                                label: 'נתוני רכב',
                                                                value: 4
                                                            }
                                                        ]
                                                    }
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="parameter-row">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            שם תבנית:
                                            </div>
                                            <div className="value">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    placeholder="כל המטפלים"
                                                    defaultValue={''}
                                                    value={''}
                                                    onChange={emptyFunc}
                                                    options={
                                                        [
                                                            
                                                        ]
                                                    }
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            תמונת רקע:
                                            </div>
                                            <div className="value">
                                                <Select
                                                    style={{ width: '100%' }}
                                                    placeholder="כל המטפלים"
                                                    defaultValue={''}
                                                    value={''}
                                                    onChange={emptyFunc}
                                                    options={
                                                        [
                                                            
                                                        ]
                                                    }
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                            לוגו:
                                            </div>
                                            <div className="value">
                                                <input type='checkbox' />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='parameter-row single-item'>
                                    <div className={`parameter-item`}>
                                        <div>
                                            <Editor
                                                onInit={(evt, editor) => editorRef.current = editor}
                                                apiKey='djtel3sjck5h6t7794w5lrm3q570rvj1rxr48es3xq7ft83w'
                                                initialValue={''}
                                                init={{
                                                    height: 250,
                                                    width: 750,
                                                    menubar: false,
                                                    plugins: [
                                                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                    ],
                                                    language: "he_IL",
                                                    toolbar: 'undo redo | blocks | ' +
                                                        'bold italic forecolor | alignleft aligncenter ' +
                                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                                        'removeformat | help',
                                                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                                }}
                                                onChange={emptyFunc}
                                            />
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="popup-footer">
                        <button className="button blue pointer"  onClick={(e:any)=>emptyFunc()}>
                            שמור תבנית
                        </button>
                        <button className="button blue pointer"  onClick={(e:any)=>emptyFunc()}>
                            נקה
                        </button>
                        <button className="button white blue-border pointer"  onClick={(e:any)=>closePopup()}>
                            ביטול
                        </button>
                    </div>
                </div>
            </section>
        </div>
      </>  
        
      );
    // }
  }
  export default ClientTreatmentTabConfigPopup;